import React from 'react';
import { Carousel } from 'antd';
import Image from 'next/image';
import type { CarouselProps } from 'antd';
import { TrendingCreatorCard } from '@/components/Designers';
import './index.less';
const FeaturedCreator = ({
  creators = [],
}: {
  creators: { handle: string; buttonText: string; avatarUrl: string; title: string }[];
}) => {
  const SamplePrevArrow = ({ ...props }) => (
    <Image src="/images/prev-white-bg.png" alt="prevArrow" width={20} height={20} {...props} />
  );

  const SampleNextArrow = ({ ...props }) => (
    <Image src="/images/next-white-bg.png" alt="prevArrow" width={20} height={20} {...props} />
  );
  const carouselSettings: CarouselProps = {
    dots: false,
    infinite: true,
    accessibility: true,
    arrows: false,
    autoplay: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    className: 'carousel',
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  return (
    <div className="featured-creator-container">
      <div className="carousel-container">
        <Carousel {...carouselSettings}>
          {(creators || []).map((creator, index) => (
            <TrendingCreatorCard key={`carousel-item-${index}`} creator={creator} />
          ))}
        </Carousel>
      </div>
    </div>
  );
};
export default FeaturedCreator;
